import React, { Component } from "react";
import IntelligenceSensorsList from "../sections/intellegence/intelligenceSensorsList";
import { getDashboard } from "../../shared/services/sensors.data.service";
import Scrollbars from "react-custom-scrollbars-2";
import styles from "./dashboards.module.scss";
import getDates from "../../shared/services/date.service";

class Dashboards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkIndex: props.dataState ? props.dataState.checkIndex : 0,
    };
  }

  componentDidMount() {
    const { scrollbar } = this.refs;

    scrollbar.scrollLeft(this.props.dataState.scroll);
  }

  componentWillUnmount() {
    const { checkIndex } = this.state;
    const { scrollbar } = this.refs;

    this.props.onSetDataState({ scroll: scrollbar.getScrollLeft(), checkIndex: checkIndex });
  }

  getTabs() {
    const { positionsData } = this.props;
    const { checkIndex } = this.state;
    const tabs = ["За весь период"];

    positionsData.days.forEach((day) => {
      const dayOfWeek = getDates.getDayOfWeekFormat2(day.day);
      tabs.push(`${day.day} ${dayOfWeek}`);
    });

    return tabs.map((tab, index) => {
      return (
        <div
          key={"Tab_" + index}
          className={checkIndex === index ? styles.container_tab_active : styles.tabItem}
          onClick={() => this.setState({ checkIndex: index })}
        >
          {tab}
        </div>
      );
    });
  }

  getDashboar() {
    const { positionsData, vehicleReport } = this.props;
    const { checkIndex } = this.state;

    if (vehicleReport === null || vehicleReport === undefined) {
      return null;
    }

    if (vehicleReport.dashboards === undefined) {
      return null;
    }

    if (checkIndex === 0) {
      return <IntelligenceSensorsList data={getDashboard(vehicleReport.dashboards, positionsData.dashboard)} />;
    }

    return <IntelligenceSensorsList data={getDashboard(vehicleReport.dashboards, positionsData.days[checkIndex - 1].dashboard)} />;
  }

  render() {
    return (
      <div className={styles.dashboardsContainer}>
        <div className={styles.tabsContainer}>
          <Scrollbars
            ref="scrollbar"
            style={{ height: "35px" }}
            autoHide={false}
            autoHeightMax={10}
            renderTrackVertical={() => <div></div>}
          >
            <div className={styles.tabsRows}>{this.getTabs()}</div>
          </Scrollbars>
        </div>

        {this.getDashboar()}
      </div>
    );
  }
}

export default Dashboards;
